import { useCallback, useEffect, useState } from "react";

const KEY = "n365-saved";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

export function useSaved() {
  const [saved, setSaved] = useState(read);
  useEffect(() => {
    const sync = () => setSaved(read());
    window.addEventListener("n365-saved", sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener("n365-saved", sync); window.removeEventListener("storage", sync); };
  }, []);
  const toggle = useCallback((a) => {
    const cur = read();
    const { content, ...lite } = a;
    const next = cur.some((x) => x.id === a.id) ? cur.filter((x) => x.id !== a.id) : [lite, ...cur];
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("n365-saved"));
    return next.some((x) => x.id === a.id);
  }, []);
  const isSaved = useCallback((id) => saved.some((x) => x.id === id), [saved]);
  return { saved, toggle, isSaved };
}
